import React, { useEffect, useRef, useState } from 'react';

/* Paylaşılan arayüz parçaları — Telegram modülüyle aynı görsel dil */

export const GRADS = [['#ff885e', '#ff516a'], ['#ffcd6a', '#ffa85c'], ['#82b1ff', '#665fff'], ['#a0de7e', '#54cb68'], ['#53edd6', '#28c9b7'], ['#72d5fd', '#2a9ef1'], ['#e0a2f3', '#d669ed']];
export const NAME_COLORS = ['#ff7a72', '#ffaa5c', '#b38bff', '#5fcf7a', '#4fd1c5', '#6ab3f3', '#f27eb5'];

export function peerIndex(id) {
  const s = String(id ?? '');
  const digits = s.replace(/\D/g, '');
  if (digits) return Number(digits.slice(-9)) % 7;
  let h = 0;
  for (const ch of s) h = (h * 31 + ch.codePointAt(0)) >>> 0;
  return h % 7;
}

export function initials(name) {
  const words = String(name || '?').trim().split(/\s+/).filter(Boolean);
  const pick = w => (w.match(/[A-Za-zÇĞİÖŞÜçğıöşü0-9]/) || [w[0]])[0] || '';
  if (!words.length) return '?';
  return words.slice(0, 2).map(pick).join('').toUpperCase() || '?';
}

const P = {
  search: <><circle cx="11" cy="11" r="7" /><path d="M20.5 20.5l-4.2-4.2" /></>,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  back: <path d="M15 5l-7 7 7 7" />,
  check: <path d="M4.5 12.5l5 5 10-11" />,
  checkCircle: <><circle cx="12" cy="12" r="9" /><path d="M8 12.3l2.8 2.8L16.3 9.5" /></>,
  plus: <path d="M12 5v14M5 12h14" />,
  attach: <path d="M20.5 11.3l-8.3 8.3a5.3 5.3 0 0 1-7.5-7.5l8.6-8.6a3.5 3.5 0 0 1 5 5l-8.6 8.6a1.8 1.8 0 0 1-2.5-2.5l7.9-7.9" />,
  send: <path d="M3.4 20.4l17.45-7.48a1 1 0 0 0 0-1.84L3.4 3.6a.99.99 0 0 0-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91z" fill="currentColor" stroke="none" />,
  bolt: <path d="M13 2.5L4.5 13.5H11l-1 8 8.5-11H12z" />,
  info: <><circle cx="12" cy="12" r="9" /><path d="M12 11v6M12 7.5v.5" /></>,
  external: <><path d="M14 4h6v6M20 4l-9 9" /><path d="M18 14v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4" /></>,
  users: <><circle cx="9" cy="8.5" r="3.5" /><path d="M2.5 19.5c.9-3 3.4-4.8 6.5-4.8s5.6 1.8 6.5 4.8" /><path d="M15.5 5.2a3.5 3.5 0 0 1 0 6.6M17.8 14.9c1.8.6 3.1 2.3 3.7 4.6" /></>,
  bot: <><rect x="4" y="8" width="16" height="11" rx="3" /><path d="M12 4v4M9 13h.01M15 13h.01" /></>,
  heart: <path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10z" />,
  megaphone: <><path d="M4 10v4a1 1 0 0 0 1 1h2l6 4V5L7 9H5a1 1 0 0 0-1 1z" /><path d="M17 8.5a5 5 0 0 1 0 7" /></>,
  edit: <><path d="M4 20h4L19 9l-4-4L4 16z" /><path d="M13.5 6.5l4 4" /></>,
  trash: <><path d="M4 7h16M10 11v6M14 11v6" /><path d="M6 7l1 12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-12" /><path d="M9 7V4.5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1V7" /></>,
  clock: <><circle cx="12" cy="12" r="8.5" /><path d="M12 7.5V12l3 2" /></>,
  save: <><path d="M5 4h11l3 3v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z" /><path d="M8 4v5h7V4M8 20v-6h8v6" /></>,
  image: <><rect x="3" y="4" width="18" height="16" rx="3" /><circle cx="8.5" cy="9.5" r="1.7" /><path d="M21 15.5l-5-5L5.5 20" /></>,
  link: <><path d="M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1.2 1.2" /><path d="M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2" /></>,
  history: <><path d="M3.5 12a8.5 8.5 0 1 0 2.6-6.1" /><path d="M3.5 4v4h4M12 8v4.5l3 2" /></>,
  pencil: <><path d="M4 20h4L19 9l-4-4L4 16z" /></>,
  tag: <><path d="M3.5 12.3V4.5a1 1 0 0 1 1-1h7.8l8.2 8.2a1.5 1.5 0 0 1 0 2.1l-6.1 6.1a1.5 1.5 0 0 1-2.1 0z" /><circle cx="8" cy="8" r="1.3" /></>,
  note: <><path d="M5 4h14v10l-6 6H5z" /><path d="M13 20v-6h6" /></>,
  chat: <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H10l-4.5 4v-4A2.5 2.5 0 0 1 4 13.5z" />,
  file: <><path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" /><path d="M14 3v5h5" /></>,
  star: <path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z" />,
  down: <path d="M6 9.5l6 6 6-6" />,
  dashboard: <><rect x="3.5" y="3.5" width="7" height="7" rx="2" /><rect x="13.5" y="3.5" width="7" height="7" rx="2" /><rect x="3.5" y="13.5" width="7" height="7" rx="2" /><rect x="13.5" y="13.5" width="7" height="7" rx="2" /></>,
  chart: <path d="M5 20V12M10 20V6M15 20v-9M20 20V4" />,
  globe: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18" /></>,
  device: <><rect x="7" y="2.5" width="10" height="19" rx="2.5" /><path d="M11 18h2" /></>,
  card: <><rect x="2.5" y="5" width="19" height="14" rx="2.5" /><path d="M2.5 10h19M6 15h4" /></>,
  game: <><rect x="2.5" y="7" width="19" height="11" rx="5" /><path d="M7 10.5v4M5 12.5h4M15.5 11.5h.01M18 13.5h.01" /></>,
  crown: <path d="M3.5 8l4 4 4.5-6 4.5 6 4-4-2 11h-13z" />,
  calendar: <><rect x="3.5" y="5" width="17" height="15" rx="2.5" /><path d="M3.5 10h17M8 3v4M16 3v4" /></>,
  copy: <><rect x="8.5" y="8.5" width="11.5" height="11.5" rx="2.5" /><path d="M15.5 8.5V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7.5a2 2 0 0 0 2 2h2.5" /></>,
  refresh: <><path d="M20 11a8 8 0 0 0-14.5-4.5L4 8" /><path d="M4 4v4h4M4 13a8 8 0 0 0 14.5 4.5L20 16" /><path d="M20 20v-4h-4" /></>,
  play: <path d="M8 5.5v13a1 1 0 0 0 1.5.86l10.6-6.5a1 1 0 0 0 0-1.72L9.5 4.64A1 1 0 0 0 8 5.5z" />,
  pause: <><rect x="6.5" y="5" width="4" height="14" rx="1.2" /><rect x="13.5" y="5" width="4" height="14" rx="1.2" /></>,
  flow: <><circle cx="6" cy="6" r="2.5" /><circle cx="18" cy="12" r="2.5" /><circle cx="6" cy="18" r="2.5" /><path d="M8.5 6H12a3 3 0 0 1 3 3v.5M8.5 18H12a3 3 0 0 0 3-3v-.5" /></>,
  keyboard: <><rect x="2.5" y="6" width="19" height="12" rx="2.5" /><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M7 14h10" /></>,
  sparkle: <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 16l.8 2.2L22 19l-2.2.8L19 22l-.8-2.2L16 19l2.2-.8z" />,
  ticket: <><path d="M3 8a2 2 0 0 0 2-2h14a2 2 0 0 0 2 2v2a2 2 0 0 0 0 4v2a2 2 0 0 0-2 2H5a2 2 0 0 0-2-2v-2a2 2 0 0 0 0-4z" /><path d="M14 6v12" strokeDasharray="2 2" /></>,
  clipboard: <><rect x="5" y="4" width="14" height="17" rx="2.5" /><path d="M9 4.5V3h6v1.5M9 10h6M9 14h6M9 18h3" /></>,
  key: <><circle cx="8" cy="15" r="4" /><path d="M11 12l8.5-8.5M16 7l2.5 2.5M14 9l2 2" /></>,
  userPlus: <><circle cx="10" cy="8" r="4" /><path d="M3 20.5c1.1-3.4 3.8-5.5 7-5.5 1.5 0 2.9.4 4 1.2M18 14v6M15 17h6" /></>,
  user: <><circle cx="12" cy="8" r="4" /><path d="M4.5 20.5c1.2-3.6 4-5.5 7.5-5.5s6.3 1.9 7.5 5.5" /></>,
  download: <><path d="M12 4v11M7.5 11L12 15.5 16.5 11" /><path d="M5 19.5h14" /></>,
  filter: <path d="M4 5h16l-6 7.5V19l-4 1.5v-8z" />,
  money: <><rect x="2.5" y="6" width="19" height="12" rx="2.5" /><circle cx="12" cy="12" r="2.6" /><path d="M6 9.5v5M18 9.5v5" /></>,
  click: <><path d="M9 3.5v3M3.5 9h3M4.9 4.9l2.1 2.1M13 13l7.5 3-3 1.5-1.5 3z" /><path d="M10 10l3 3" /></>,
  building: <><rect x="4" y="3.5" width="11" height="17" rx="1.5" /><path d="M15 9.5h4a1 1 0 0 1 1 1v10H15M7.5 7.5h4M7.5 11h4M7.5 14.5h4" /></>,
  target: <><circle cx="12" cy="12" r="8.5" /><circle cx="12" cy="12" r="4.5" /><circle cx="12" cy="12" r="1" /></>,
  shield: <path d="M12 3l7.5 3v5.5c0 4.5-3.2 8.2-7.5 9.5-4.3-1.3-7.5-5-7.5-9.5V6z" />,
  alert: <><circle cx="12" cy="12" r="9" /><path d="M12 7.5v5.5M12 16.2v.3" /></>,
  arrowRight: <path d="M5 12h14M13 6l6 6-6 6" />,
  trophy: <><path d="M7 4h10v5a5 5 0 0 1-10 0z" /><path d="M7 6H4.5v1.5A3.5 3.5 0 0 0 8 11M17 6h2.5v1.5A3.5 3.5 0 0 1 16 11M12 14v3.5M8.5 20.5h7M9.5 17.5h5" /></>,
  coin: <><circle cx="12" cy="12" r="8.5" /><path d="M14.5 9.2c-.5-.8-1.4-1.2-2.5-1.2-1.5 0-2.6.8-2.6 2s1.1 1.6 2.6 2 2.7.8 2.7 2-1.2 2-2.7 2c-1.1 0-2.1-.5-2.6-1.3M12 6.5v1.5M12 16v1.5" /></>,
  fire: <path d="M12 21c-3.9 0-6.5-2.6-6.5-6.2 0-3.2 2.3-5.4 3.6-8.3.3 1.8 1.2 3 2.4 3.6.3-2.6 1.4-4.8 3.4-6.6.2 3.1 1.6 5 2.6 6.6.7 1.2 1 2.3 1 3.7C18.5 18.1 15.9 21 12 21z" />,
  bell: <><path d="M6 16.5V11a6 6 0 0 1 12 0v5.5l1.5 2h-15z" /><path d="M10 20.5a2.2 2.2 0 0 0 4 0" /></>,
  radio: <><circle cx="12" cy="12" r="2" /><path d="M8.2 8.2a5.4 5.4 0 0 0 0 7.6M15.8 8.2a5.4 5.4 0 0 1 0 7.6M5.3 5.3a9.5 9.5 0 0 0 0 13.4M18.7 5.3a9.5 9.5 0 0 1 0 13.4" /></>,
  moon: <path d="M19.5 14.5A8 8 0 0 1 9.5 4.5a8 8 0 1 0 10 10z" />,
  eye: <><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12z" /><circle cx="12" cy="12" r="3" /></>,
  trendUp: <path d="M3.5 17l6-6 4 4 7-7.5M15 7.5h5.5V13" />,
  trendDown: <path d="M3.5 7l6 6 4-4 7 7.5M15 16.5h5.5V11" />,
  chevR: <path d="M9.5 5.5l6.5 6.5-6.5 6.5" />,
  level: <path d="M4 20h4v-5H4zM10 20h4V10h-4zM16 20h4V4h-4z" />,
  upload: <><path d="M12 15.5V4.5M7.5 9L12 4.5 16.5 9" /><path d="M5 19.5h14" /></>,
  inbox: <><path d="M3.5 13.5l2.6-7.2A2 2 0 0 1 8 5h8a2 2 0 0 1 1.9 1.3l2.6 7.2V18a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z" /><path d="M3.5 13.5H8l1.5 2.5h5l1.5-2.5h4.5" /></>,
  webhook: <><circle cx="6.5" cy="17" r="2.5" /><circle cx="17.5" cy="17" r="2.5" /><circle cx="12" cy="6.5" r="2.5" /><path d="M10.7 8.7L7.6 14.8M9 17h6M13.3 8.7l3.1 6.1" /></>,
  grid: <><rect x="3.5" y="3.5" width="7" height="7" rx="1.5" /><rect x="13.5" y="3.5" width="7" height="7" rx="1.5" /><rect x="3.5" y="13.5" width="7" height="7" rx="1.5" /><rect x="13.5" y="13.5" width="7" height="7" rx="1.5" /></>,
  swap: <path d="M7 4.5L3.5 8 7 11.5M3.5 8h13M17 12.5l3.5 3.5-3.5 3.5M20.5 16h-13" />,
};

export function Ic({ n, s = 22, c, sw = 1.8, style }) {
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c || 'currentColor'} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block', flexShrink: 0, ...style }}>
      {P[n]}
    </svg>
  );
}

export function Avatar({ id, name, size = 42, children, ring, style }) {
  const g = GRADS[peerIndex(id ?? name)];
  return (
    <div style={{ width: size, height: size, borderRadius: '50%', flexShrink: 0, background: `linear-gradient(180deg, ${g[0]}, ${g[1]})`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 600, fontSize: Math.round(size * 0.38), userSelect: 'none', position: 'relative', boxShadow: ring ? `0 0 0 2px ${ring}` : undefined, ...style }}>
      {children || initials(name)}
    </div>
  );
}

export function Spinner({ size = 26 }) {
  return (
    <div style={{ width: size, height: size, border: '3px solid rgba(255,255,255,.15)', borderTopColor: 'var(--link, #6ab3f3)', borderRadius: '50%', animation: 'uiSpin .8s linear infinite' }}>
      <style>{'@keyframes uiSpin { to { transform: rotate(360deg); } }'}</style>
    </div>
  );
}

export function fmtNum(n) {
  return Number(n || 0).toLocaleString('tr-TR');
}

/* Sayısal kart: ikon dairesi + değer + etiket (+ alt satır) */
export function StatCard({ icon, label, value, color = 'var(--link)', bg = 'var(--accent-s)', sub, subColor, onClick }) {
  return (
    <div className="stat-card" onClick={onClick} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 14, cursor: onClick ? 'pointer' : 'default' }}>
      <div className="ic-circle" style={{ width: 44, height: 44, background: bg, color }}><Ic n={icon} s={22} /></div>
      <div style={{ minWidth: 0 }}>
        <div className="stat-value" style={{ marginBottom: 1 }}>{value}</div>
        <div className="stat-label truncate">{label}</div>
        {sub != null && sub !== '' && <div style={{ fontSize: 12, color: subColor || 'var(--text3)', marginTop: 2, display: 'flex', alignItems: 'center', gap: 3 }}>{sub}</div>}
      </div>
    </div>
  );
}

/* Elemanın genişliğini izler (grafikler gerçek piksel genişliğinde çizilsin diye) */
export function useWidth() {
  const ref = useRef(null);
  const [w, setW] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    setW(el.clientWidth);
    if (typeof ResizeObserver === 'undefined') {
      const h = () => setW(el.clientWidth);
      window.addEventListener('resize', h);
      return () => window.removeEventListener('resize', h);
    }
    const ro = new ResizeObserver(() => setW(el.clientWidth));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return [ref, w];
}

/* Telegram tarzı alt bildirim — const [toastEl, toast] = useToast(); toast('Kaydedildi') / toast('Hata', 'err') */
export function useToast() {
  const [t, setT] = useState(null);
  useEffect(() => {
    if (!t) return undefined;
    const id = setTimeout(() => setT(null), 3200);
    return () => clearTimeout(id);
  }, [t]);
  const el = t ? (
    <div style={{ position: 'fixed', left: '50%', bottom: 'calc(24px + env(safe-area-inset-bottom))', transform: 'translateX(-50%)', zIndex: 5000, background: 'rgba(23,33,43,.97)', border: '1px solid var(--border)', color: 'var(--text)', padding: '10px 16px', borderRadius: 12, fontSize: 14, boxShadow: 'var(--shadow-md)', display: 'flex', alignItems: 'center', gap: 8, maxWidth: 'calc(100vw - 32px)', animation: 'fadeIn .15s ease' }}>
      <Ic n={t.type === 'err' ? 'alert' : 'checkCircle'} s={18} c={t.type === 'err' ? 'var(--danger)' : 'var(--success)'} />
      <span>{t.msg}</span>
    </div>
  ) : null;
  const show = (msg, type = 'ok') => setT({ msg, type, k: Date.now() });
  return [el, show];
}

/* İnce ilerleme çubuğu */
export function Bar({ pct, color = 'var(--accent)', h = 6 }) {
  return (
    <div style={{ height: h, background: 'var(--surface3)', borderRadius: h, overflow: 'hidden', flex: 1, minWidth: 0 }}>
      <div style={{ height: '100%', width: Math.max(0, Math.min(100, pct || 0)) + '%', background: color, borderRadius: h, transition: 'width .5s ease' }} />
    </div>
  );
}
